import React from 'react';
import LineBehind from '../login/components/LineBehind';
import styled from 'styled-components';
import LogoSvg from '../login/components/LogoSvg';
import { Col, Row } from 'antd';
import IcHomeSalon from './components/homeIcons/IcHomeSalon';
import IcHomeRetail from './components/homeIcons/IcHomeRetail';
import IcHomeRestaurant from './components/homeIcons/IcHomeRestaurant';
import IcHomeBillard from './components/homeIcons/IcHomeBillard';
import { useNavigate } from 'react-router-dom';

type ProductType = 'nails' | 'retail' | 'restaurant' | 'pool';

const HomePage = () => {
  const navigate = useNavigate();

  const handleNavigate = (product: ProductType) => {
    switch (product) {
      case 'retail':
        // navigate('/product/retail');
        break;
      case 'restaurant':
        // navigate('/product/restaurant');
        break;
      case 'pool':
        // navigate('/product/pool');
        break;
      case 'nails':
      default:
        navigate('/login');
    }
  };

  return (
    <Container>
      <LineBehind />
      <LogoBox>
        <LogoSvg />
      </LogoBox>
      <ContentBox>
        <TitleStyled>
          <span>Fozito POS System</span>
          <Rectangle />
        </TitleStyled>
        <Row gutter={[16, 24]}>
          <Col span={12}>
            <ProductItem onClick={() => handleNavigate('nails')}>
              <IcHomeSalon />
              <ProductText>Nails & Salon POS System</ProductText>
            </ProductItem>
          </Col>
          <Col span={12}>
            <ProductItem onClick={() => handleNavigate('retail')}>
              <IcHomeRetail />
              <ProductText>Retail POS System</ProductText>
            </ProductItem>
          </Col>
          <Col span={12}>
            <ProductItem onClick={() => handleNavigate('restaurant')}>
              <IcHomeRestaurant />
              <ProductText>Restaurants POS System</ProductText>
            </ProductItem>
          </Col>
          <Col span={12}>
            <ProductItem onClick={() => handleNavigate('pool')}>
              <IcHomeBillard />
              <ProductText>Pool POS System</ProductText>
            </ProductItem>
          </Col>
        </Row>
      </ContentBox>
    </Container>
  );
};

export default HomePage;

const Container = styled.div`
  height: 100vh;
  background-color: #e9eded;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoBox = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
`;

const ContentBox = styled.div`
  z-index: 1;
  display: flex;
  width: 770px;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

const TitleStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  color: #1d2129;
  text-align: center;
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
`;

const Rectangle = styled.div`
  width: 55px;
  height: 4px;
  background: #2d6772;
`;

const ProductItem = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #86909c;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4), 0px 4px 8px -3px rgba(45, 35, 66, 0.3),
    0px -3px 0px 0px #d6d6e7 inset;
  cursor: pointer;

  &:hover {
    background: #efecece0;
  }
`;

const ProductText = styled.div`
  // align-self: stretch;
  color: #1d2129;
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
